/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_LoggedInputs */

const en_cook_done_logged = /** @type {(inputs: Cook_Done_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added to your history`)
};

const de_cook_done_logged = /** @type {(inputs: Cook_Done_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Verlauf eingetragen`)
};

/**
* | output |
* | --- |
* | "Added to your history" |
*
* @param {Cook_Done_LoggedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_logged = /** @type {((inputs?: Cook_Done_LoggedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_LoggedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_logged(inputs)
	return en_cook_done_logged(inputs)
});